import { AnzRdEnvironment } from 'global-types';

export const environment: AnzRdEnvironment = {
  production: true,
  env: 'production',
  nydusNetworkApiBaseUrl: 'https://anz-nn.kaligo.com',
  translationBaseUrl: './assets/i18n',
  guardhouseApiUrl: 'https://auth.anzrewards.com',
  clientId: 'dd0431f3-e1e7-4185-ac1c-13a1a10bc2cb',
  connection: 'email',
  scope: 'openid,address,email,phone,profile,custom',
  redirectUri: 'https://www.anzrewards.com',
  stripeApiKey:
    'pk_live_51I3Z9SCcsFvSbXe7nfMwEelEq00oFY3soA9YHCY3aUo9OcbWM4mZgsMrYFNnY6wdEtMDfzYvPG2JDUDI1IXLPueU00SEIMbITO',
  travelEdgeBaseUrl: 'https://anz-travel.kaligo.com',
  brandName: 'ANZ',
  shortBrandName: 'ANZ',
  hermesMode: 'refresh-token-rotation',
  idleCheckConfig: {
    timeout: 1080,
    promptTimeout: 120,
  },
  sessionCheckPollInterval: 60,
  cookiesConfig: {
    localeCookieName: 'ascenda.locale',
    localeCookieDomain: 'www.anzrewards.com',
  },
  prismicConfig: {
    apiUrl: 'https://ascendaloyalty.prismic.io/api/v2',
    accessToken:
      'MC5ZSFpteHhNQUFDSUFxMERB.fu-_vX3vv73vv73vv70UFu-_vXJQ77-977-977-977-9I--_vU84R--_vR_vv70z77-977-9Ue-_vUNU77-977-9',
  },
  physicalAddressConfig: {
    autocompleteEndpoint:
      'https://api.addressfinder.io/api/au/address/autocomplete/?',
    detailEndpoint: 'https://api.addressfinder.io/api/au/address/metadata/?',
    queryParams: {
      key: '6MEFUL83HYQC4AVWPJT9',
      format: 'json',
      au_paf: '1',
      highlight: '1',
    },
    queryParamOptions: {
      queryKeyword: 'q',
      idKeyword: 'id',
    },
  },
  appId: '587383d6-6a11-4f5c-b964-086912c5cf0d',
  unleashAppName: 'rd-anz-prod',
  unleashClientKey:
    '*:production.ed9dc866a8362d926412ad673806fed91176182036fdca279f983b42',
};
